import { SizeProp } from "@fortawesome/fontawesome-svg-core";
import * as React from "react";
import { IconDelete } from "../icons/IconDelete";
import { MprcIconButton, MprcIconButtonProps } from "../MprcIconButton";
import { useMprcTheme } from "../MprcThemeProvider";

interface IconButtonDeleteProps extends MprcIconButtonProps{
    iconSize?: SizeProp;
}

export const IconButtonDelete: React.FC<IconButtonDeleteProps> = ({ title, iconSize, ...rest }) => {
    const { theme } = useMprcTheme();
    const lTitle = title || theme.iconButtons.IconButtonDelete.title;

    return (
        <MprcIconButton
            {...rest}
            title={lTitle}
        >
            <IconDelete fixedWidth size={iconSize} />
        </MprcIconButton>
    );
};
